import { ATTENDEE_EVENTS, USER_EVENTS } from "../constants/authConstants";

export const userEvents = (payload) => ({
  type: USER_EVENTS,
  payload,
});

export const attendeeEvents = (payload) => ({
  type: ATTENDEE_EVENTS,
  payload,
});
